import { render, staticRenderFns } from "./BlankPageLogin.vue?vue&type=template&id=e494dfc2&"
import script from "./BlankPageLogin.vue?vue&type=script&lang=js&"
export * from "./BlankPageLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports